import { FC } from 'react';

type Props = {
	className?: string;
};

const ArrowDownIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				d='M14.7093 7.14615C15.0269 7.39178 15.0947 7.86128 14.8608 8.19479C14.6791 8.45385 14.4974 8.7001 14.338 8.9146C14.0198 9.3427 13.5817 9.91615 13.1057 10.4917C12.6328 11.0636 12.1085 11.6548 11.6191 12.1089C11.3751 12.3352 11.123 12.5433 10.8772 12.699C10.6509 12.8421 10.3401 13 10 13C9.65996 13 9.34904 12.8421 9.12283 12.699C8.87697 12.5433 8.6249 12.3352 8.38098 12.1089C7.89149 11.6548 7.36719 11.0636 6.89431 10.4917C6.41835 9.91615 5.98027 9.3427 5.66205 8.9146C5.50265 8.7001 5.3209 8.45385 5.13919 8.1948C4.90526 7.86128 4.97311 7.39178 5.29074 7.14615C5.41842 7.0474 5.56704 6.99987 5.71432 7H10H14.2857C14.433 6.99987 14.5816 7.0474 14.7093 7.14615Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default ArrowDownIconSolid;
